import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { Button, Icon, Message } from 'semantic-ui-react';
import { setPage } from '../../redux/appSlice';
import GeographicalReport from '../Cartographie/GeographicalReport';

const useTitle = (title) => {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        }
    })
}

const GeographicalReportService = () => {
    const projectState = useSelector(state => state.project);
    const appState = useSelector(state => state.app);
    const dispatch = useDispatch();
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    
    useTitle(projectState.project.customIdentifier + ' ' + projectState.project.acronym + ' map');
    return (
        <div>
            <div className='menu'>
                <Button.Group>
                    <Button icon onClick={() => dispatch(setPage('Projects'))} color='blue' labelPosition='left'>
                        <Icon name='arrow left' />
                        Back
                    </Button>
                    <Button.Or />
                    <Button icon onClick={handlePrint} color='blue' labelPosition='right'>
                        <Icon name='print' />
                        Print
                    </Button>
                </Button.Group>
            </div>
            {appState.jems32 ? <Message warning><Message.Header>You're connected to Jems32 server.</Message.Header>Collected data may not reflect the live server please use <a href="http://jemsreports.nweurope.eu/" target="_blank" rel="noopener noreferrer">Jems Live Server</a></Message> : undefined}
            <GeographicalReport ref={componentRef} projectState={projectState} appState={appState}/>

        </div>
    );
}

export default GeographicalReportService;